module.exports = __webpack_public_path__ + "static/img/obj1.06c2446c.png";